(function () {
    console.log("testing1 suppliers");
  window.ProductDecoration = window.ProductDecoration || {};

  // Optional: if you use these in some vendor logic (you referenced them in your old code)
  window.ProductDecoration.validSetupCharges =
    window.ProductDecoration.validSetupCharges || [
      // Add names if you want to whitelist setup charge "name" fields
      // Example: "Setup", "*", "Additional Colors / Locations"
    ];

  window.ProductDecoration.validRunCharges =
    window.ProductDecoration.validRunCharges || [
      // Add names if you want to whitelist run charge "name" fields
    ];

  window.ProductDecoration.suppliers = window.ProductDecoration.suppliers || {};

  window.ProductDecoration.registerSupplier = function (vendorHandle, supplier) {
    if (!vendorHandle) vendorHandle = "default";
    window.ProductDecoration.suppliers[vendorHandle] = supplier;
  };

  window.ProductDecoration.getSupplier = function (vendorHandle) {
    return (
      window.ProductDecoration.suppliers[vendorHandle] ||
      window.ProductDecoration.suppliers["default"]
    );
  };

  // ---------- Shared Helpers ----------
  window.ProductDecoration.utils = {
    normalizeLocation(str) {
      return String(str || "")
        .replace(/upload|design|above|tumbler|grinder|drinkware|the|for/gi, "")
        .replace(/\([^)]*\)/g, "") // removes (Cooler) completely
        .trim()
        .toLowerCase();
    },

    getImprintLocation(details, detail) {
      // Your legacy code sometimes used details[0].location
      // We'll prefer detail.location if present, else fallback.
      const raw = detail?.location || details?.[0]?.location || "";
      return window.ProductDecoration.utils.normalizeLocation(raw);
    },

    findDecorationEntry(decorationData, details, detail, imprintType) {
      if (!Array.isArray(decorationData)) return null;

      const loc = window.ProductDecoration.utils.getImprintLocation(details, detail);
      const type = String(imprintType || "").trim().toLowerCase();

      return decorationData.find((item) => {
        const itemLoc = window.ProductDecoration.utils.normalizeLocation(item?.location);
        const itemType = String(item?.imprint_type || "").trim().toLowerCase();
        return itemLoc === loc && itemType === type;
      });
    },

    // Choose the closest lower tier by x_min_qty
    closestLowerTierQty(qty, tiers) {
      if (!Array.isArray(tiers) || !tiers.length) return null;
      const sorted = [...new Set(tiers.map((t) => parseInt(t?.x_min_qty, 10)).filter(Boolean))].sort(
        (a, b) => a - b
      );
      if (!sorted.length) return null;
      let chosen = sorted[0];
      for (const t of sorted) {
        if (t <= qty) chosen = t;
      }
      return chosen;
    },

    pickMaxPrice(list) {
      if (!Array.isArray(list) || !list.length) return null;
      let best = list[0];
      for (const x of list) {
        if (Number(x?.price_usd) > Number(best?.price_usd)) best = x;
      }
      return best;
    },
  };
})();
